import { useCallback } from 'react';
import uuid from 'react-uuid';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface ClientResponse {
  clientId: number;
  name: string;
  isDeleted: boolean;
  rowId: string;
}

const useGetClientApi = (companyId: string) => {
  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<ClientResponse[]>(api.client(companyId));
      const result = res.data.map((member) => ({
        ...member,
        rowId: uuid(),
      }));
      return result;
    } catch (error) {
      throw new Error(error);
    }
  }, [companyId]);

  const { value, execute } = useAsync(call, false, undefined, [] as ClientResponse[]);

  return {
    getClients: execute,
    clients: value,
  };
};

export default useGetClientApi;
